import Vue from 'vue'
import VueResource from 'vue-resource';
import VueRouter from 'vue-router';
import Vuelidate from 'vuelidate'
import VueAuth from '@websanova/vue-auth';
import Cms from './modules/vue-cms/plugin';
import App from './App.vue'
import router from './router';
import i18n from './i18n';
import { init } from '@sentry/browser';

Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(Vuelidate);

Vue.router = router;

Vue.use(VueAuth, {
    http: require('@websanova/vue-auth/drivers/http/vue-resource.1.x.js'),
    auth:  {
        request: function (req, token) {
            this.options.http._setHeaders.call(this, req, {Authorization: 'Bearer ' + token});
        },
        response: function (res) {
            return res.body.access_token;
        }
    },
    
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
    registerData: {method: 'POST'},
    refreshData: {method: 'POST'},
    logoutData: {redirect: '/'},
    authRedirect: {name: 'login'},
    notFoundRedirect: {name: 'dashboard'}
});

Vue.use(Cms, {
    urls: {
        strings: `${process.env.VUE_APP_ROOT_API}admin-editable/string`,
        files: `${process.env.VUE_APP_ROOT_API}admin-editable/file`,
    },
});

/* Interceptor para unauthorized */
Vue.http.interceptors.push(function(request, next) {
    let wasLoggedIn = Vue.auth.check();

    next(function (res) {
        if(wasLoggedIn){
            if(res.status === 401){
                Vue.auth.logout({redirect: {name: 'signedout'}});
            }
        }

        if(res.url.includes('auth/refresh')){
            if (res.status === 401 || res.status === 0) {
                //Vue.auth.logout();
                //fixme: desloguear al usuario con vue-auth
                localStorage.removeItem('default_auth_token');
                location.reload();
            }
        }
    });
});
/* Interceptor para unauthorized */

Vue.http.options.root = process.env.VUE_APP_ROOT_API_WRITE;
Vue.config.productionTip = false;

if(process.env.VUE_APP_SENTRY_DSN){
    init({
        dsn: process.env.VUE_APP_SENTRY_DSN,
    });
}

let app = new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');

/* Interceptor para anticache */
Vue.http.interceptors.push(function(request, next) {
    request.params['lang'] = app.$i18n.locale;

    if(Vue.auth.check()){
        request.params['cdn_session_id'] = Vue.auth.token(); //TODO: MD5
    }
});
/* Interceptor para anticache */

export default app;